import {
  ICustomProductOptionConfig,
  IProductFileWithFile,
} from "@evennt-tech/api-v2-core";

type ConfigImageSource = Pick<
  ICustomProductOptionConfig,
  "primaryImageId" | "cpoConfigToFiles" | "items"
>;

export const getCustomConfigImage = (
  { primaryImageId, cpoConfigToFiles, items }: ConfigImageSource,
  files: IProductFileWithFile[] = []
): IProductFileWithFile | undefined => {
  if (!files.length) {
    return undefined;
  }

  if (primaryImageId) {
    const primaryImage = files.find(({ id }) => id === primaryImageId);

    if (primaryImage) {
      return primaryImage;
    }
  }

  const productFileId =
    cpoConfigToFiles?.[0]?.productFileId ??
    items?.find(({ cpoConfigItemToFiles }) => !!cpoConfigItemToFiles?.[0])
      ?.cpoConfigItemToFiles?.[0]?.productFileId;

  if (!productFileId) {
    return undefined;
  }

  return files.find(({ id }) => id === productFileId);
};
